import {
  GET_FOLLOWED_CONTENT_REQUEST,
  GET_FOLLOWED_CONTENT_SUCCESS,
  GET_FOLLOWED_CONTENT_ERROR,
  UNSUBSCRIBE_FOLLOWED_CONTENT_REQUEST,
  UNSUBSCRIBE_FOLLOWED_CONTENT_SUCCESS,
  UNSUBSCRIBE_FOLLOWED_CONTENT_ERROR,
} from "../../constants/action-types";
import { ApiService } from "../../util/ApiService";
import config from "../../util/api-config";
import { followedContentErrorViewModel } from "../../constants/followedContent-error-viewModel";
import { EVENT_BUS_EVENTS } from "../../util/useEventBus";
import { FEED_TYPE } from "../../constants/feed-type";

const apiService = new ApiService(config.personalizationEdge);

export const getFollowedContent = async (dispatch) => {
  try {
    dispatch({ type: GET_FOLLOWED_CONTENT_REQUEST });

    const {
      data: { viewModel },
    } = await apiService.get(`/follows`);
    dispatch({ type: GET_FOLLOWED_CONTENT_SUCCESS, payload: viewModel });
  } catch (error) {
    dispatch({
      type: GET_FOLLOWED_CONTENT_ERROR,
      payload: followedContentErrorViewModel,
    });
  }
};

export const unsubscribeFollowedContent = async (
  dispatch,
  type,
  id,
  eventBus
) => {
  try {
    dispatch({ type: UNSUBSCRIBE_FOLLOWED_CONTENT_REQUEST });

    const {
      data: { error },
    } = await apiService.delete(`/follows/${type}/${id}`);

    if (error) {
      dispatch({ type: UNSUBSCRIBE_FOLLOWED_CONTENT_ERROR, payload: error });
      return;
    }

    dispatch({ type: UNSUBSCRIBE_FOLLOWED_CONTENT_SUCCESS, payload: { id } });

    if (type === FEED_TYPE.SPECIALTY) {
      eventBus.emit(EVENT_BUS_EVENTS.SPECIALTY_UNSUBSCRIBED, null, {
        specialtyId: id,
      });
    }

    if (type === FEED_TYPE.TOPIC) {
      eventBus.emit(EVENT_BUS_EVENTS.TOPIC_UNSUBSCRIBED, null, {
        topicAn: id,
      });
    }
  } catch (error) {
    dispatch({ type: UNSUBSCRIBE_FOLLOWED_CONTENT_ERROR });
  }
};
